import { render, staticRenderFns } from "./SewerProfile.vue?vue&type=template&id=af0b1238&scoped=true&"
import script from "./SewerProfile.vue?vue&type=script&lang=js&"
export * from "./SewerProfile.vue?vue&type=script&lang=js&"
import style0 from "./SewerProfile.vue?vue&type=style&index=0&id=af0b1238&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af0b1238",
  null
  
)

export default component.exports